import SkapaBanner, { type BannerProps } from "@ingka/banner";

export const Banner = (props: BannerProps) => {
  return <SkapaBanner prefix="saleslead__" {...props} />;
};
